module.exports = __webpack_public_path__ + "media/images/elizabethtown-ky-realtors-3x-67906744.jpg";